var render = function render(){var _vm=this,_c=_vm._self._c;return _c('home-five')
}
var staticRenderFns = []

export { render, staticRenderFns }